<template>
    <div class="py-2">
        <div
            class="flex items-stretch bg-minplan-beige hover:bg-minplan-lightbeige text-minplan-blue h-36 relative transition-colors group/card overflow-hidden">
            <!-- Main Content Link -->
            <Link :href="route('advisors.projects.show', project.uuid)" preserve-state class="flex-1 flex items-stretch min-w-0">
            <div class="flex-1 flex items-stretch min-w-0">
                <p class="flex w-1/4 h-36 shrink-0">
                    <img class="w-full h-full object-cover"
                        :src="project.image ? route('media.restore', { filename: project.image }) : '/images/noimg.png'"
                        alt="" />
                </p>
                <div class="p-4 w-3/4">
                    <span class="truncate md:text-lg inline-block w-full font-bold">
                        {{ project.name }}
                        <span v-if="project.deadlineColor && $page.props.deadline_indicator_show_in_apartment_dashboard" class="inline-flex items-center ml-2 px-1.5 py-0.5 rounded-full text-[15px] font-large bg-white/20">
                            <span class="h-2 w-2 rounded-full mr-1 inline-block relative bottom-[0.033rem]" :style="{ backgroundColor: project.deadlineColor }"></span>
                            <span  class="inline-block relative bottom-[0.033rem]" :style="{ color: project.deadlineColor }">{{ project.pendingCount }}</span>
                        </span>
                    </span><br />
                    <span class="hidden md:inline-block">{{ project.street }}, {{ project.zip }} {{ project.city
                        }}</span><br />
                    <span class="hidden md:inline-block mt-2 inline-block text-minplan-darkbeige">{{
                        $t('projects.projectNumber') }} {{ project.number }}</span>
                </div>
            </div>
            <div class="hidden xl:flex p-4 w-1/4 items-center border-l border-white/20">
                <div class="flex items-center min-w-0">
                    <UserIcon class="mr-2 h-5 w-5 text-minplan-darkgreybeige shrink-0" />
                    <div>
                        <span class="block font-medium leading-tight">{{ project.responsible }}</span>
                        <small class="text-minplan-darkbeige block mt-0.5">{{ project.team }}</small>
                    </div>
                </div>
            </div>
            </Link>

            <!-- Chat Link (Separate) - Manager/Owner Only -->
            <div class="flex w-14 xl:w-24 border-l border-white/10 items-stretch shrink-0">
                <Link v-if="['owner', 'manager', 'advisor'].includes($page.props.user.currentAgencyRole)"
                    :href="route('advisors.projects.show', project.uuid)"
                    class="flex flex-col justify-center items-center w-full px-2 xl:px-4 hover:bg-white/10 transition-colors z-10"
                    title="Go to Project Chat">
                <div class="relative">
                    <ChatIcon
                        class="h-5 w-5 xl:h-6 xl:w-6 text-minplan-darkgreybeige hover:text-minplan-blue transition-colors" />

                    <span v-if="project.unread_count > 0"
                        class="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full ring-2 ring-minplan-beige">
                        {{ project.unread_count }}
                    </span>
                </div>

                <!-- hide text on mobile -->
                <span class="hidden xl:block text-[10px] font-bold text-minplan-darkbeige uppercase mt-1">
                    {{ $t('projects.messages') }}
                </span>
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import { UserIcon, ChatIcon } from "@heroicons/vue/outline";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    props: ["project"],
    name: "ProjectCard.vue",
    components: { UserIcon, ChatIcon, Link },
};
</script>

<style scoped></style>
